import React from "react";
import LegalLayout, { Section, COMPANY } from "./LegalLayout";
import { ExternalLink } from "lucide-react";

export default function LegalInfo() {
  return (
    <LegalLayout title="Informação Legal" subtitle="Identificação e RAL">
      <Section n="1" title="Identificação do fornecedor">
        <ul className="space-y-1">
          <li><strong className="text-foreground">Denominação:</strong> {COMPANY.legalName}</li>
          <li><strong className="text-foreground">NIF/NIPC:</strong> {COMPANY.nif}</li>
          <li><strong className="text-foreground">Morada:</strong> {COMPANY.address}</li>
          <li><strong className="text-foreground">Email:</strong> {COMPANY.email}</li>
          <li><strong className="text-foreground">Telefone:</strong> {COMPANY.phone}</li>
        </ul>
      </Section>

      <Section n="2" title="Livro de Reclamações">
        <p>Nos termos da lei, disponibilizamos o Livro de Reclamações em formato eletrónico. Pode apresentar a sua reclamação através da plataforma oficial:</p>
        <a href="https://www.livroreclamacoes.pt/inicio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-semibold underline underline-offset-2">
          www.livroreclamacoes.pt <ExternalLink className="w-4 h-4" />
        </a>
      </Section>

      <Section n="3" title="Resolução Alternativa de Litígios (RAL)">
        <p>Em caso de litígio de consumo, o consumidor pode recorrer a uma entidade de Resolução Alternativa de Litígios de Consumo. De acordo com a Lei n.º 144/2015, informamos:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong className="text-foreground">CNIACC — Centro Nacional de Informação e Arbitragem de Conflitos de Consumo</strong> — <a href="https://www.cniacc.pt" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-2">www.cniacc.pt</a> (entidade de competência nacional).</li>
          <li>Poderá também existir um centro de arbitragem regionalmente competente para a sua área. Recomendamos confirmar a entidade RAL a que a empresa se encontra vinculada.</li>
        </ul>
        <p>Mais informações no Portal do Consumidor: <a href="https://www.consumidor.gov.pt" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-2">www.consumidor.gov.pt</a>.</p>
      </Section>

      <Section n="4" title="Garantia de viaturas usadas">
        <p>As viaturas usadas vendidas a consumidores beneficiam da garantia legal de conformidade aplicável nos termos da legislação portuguesa em vigor. As condições específicas de cada viatura são prestadas no momento da venda.</p>
      </Section>

      <div className="rounded-2xl bg-accent/50 border border-black/5 p-5 text-sm">
        <strong className="text-foreground">Nota:</strong> a denominação social completa (forma jurídica) deve ser preenchida com os dados oficiais da empresa antes da publicação do site.
      </div>
    </LegalLayout>
  );
}
